<template>
  <div>
    <base-heading>Import Client List</base-heading>
    <base-text>
      Copy and paste a list of emails separated by semicolons or linebreaks.
      <a
        href="#"
        class="text-underlined"
        @click.prevent.stop="$emit('moreInfo')"
      >More info</a>
    </base-text>
    <textarea
      id
      v-model="list"
      class="import-textarea"
      name
      cols="30"
      rows="10"
    />
    <div class="mt-2">
      <base-button
        secondary
        expanded
        class="ml-0"
        @click="onSubmit"
      >
        Upload
      </base-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ImportClientList',
  data() {
    return {
      list: '',
    };
  },
  methods: {
    onSubmit() {
      if (this.list !== '') {
        this.$emit('onSubmit', this.list);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.import-textarea {
  width: 100%;
  border-color: rgba($black, 0.3);
  border-radius: 3px;
  height: 150px;
  margin-top: 1rem;
}
</style>
